module.exports = __webpack_public_path__ + "img/ai-task-answering.c2f08018.svg";